/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { sharedListPagesHeaderStyle } from "@monsma/App/WidgetExtensions/MyAccount/MyAccountListPagesExtension";
import { sortControlStyles } from "@monsma/Overrides/Widgets/MyLists/MyListsSortControl";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

sortControlStyles.wrapper = {
    css: css`
        max-width: 262px;
        display: flex;
        align-items: center;
        gap: 13px;

        ${screen("lte", "xs")} {
            max-width: 100%;
        }
    `,
};

sortControlStyles.toggleFilterButton = sharedListPagesHeaderStyle.toggleFilterButton;

sortControlStyles.toggleFilterButtonIcon = sharedListPagesHeaderStyle.toggleFilterButtonIcon;

sortControlStyles.label = sharedListPagesHeaderStyle.headingText;
